import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faHome } from '@fortawesome/free-solid-svg-icons';

const NotFound: React.FC = () => {
  return (
    <div className="section-container py-20 flex flex-col items-center justify-center text-center">
      <FontAwesomeIcon icon={faExclamationTriangle} className="text-primary text-6xl mb-6" />
      <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
        Page non trouvée
      </h1>
      <p className="text-xl text-gray-600 mb-8 max-w-2xl">
        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <div className="space-y-4 sm:space-y-0 sm:flex sm:space-x-4">
        <Link to="/" className="btn-primary flex items-center justify-center">
          <FontAwesomeIcon icon={faHome} className="mr-2" />
          Retour à l'accueil
        </Link>
        <Link to="/contact" className="btn-secondary inline-block">
          Nous contacter
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 